import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Loader2, Mic, Square } from 'lucide-react';
import { dictationActiveClasses, dictationButtonClasses } from './noteInstructions.styles';
import type { DictationButtonProps } from './noteInstructions.types';

/** Starts and stops hands-free instructions; spins while the stream and mic open. */
export const DictationButton = ({ status, disabled, onStart, onStop }: DictationButtonProps) => {
  const isStarting = status === 'starting';
  const isActive = status !== 'idle' && !isStarting;

  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      className={cn(dictationButtonClasses, isActive && dictationActiveClasses)}
      // Stopping stays possible while the composer is busy applying an instruction.
      disabled={!isActive && (disabled || isStarting)}
      onClick={isActive ? onStop : () => void onStart()}
      aria-label={isActive ? 'Hætta að hlusta' : 'Tala við Skríbuna'}
      aria-pressed={isActive}
    >
      {isStarting ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : isActive ? (
        <Square className="h-3.5 w-3.5 fill-current" />
      ) : (
        <Mic className="h-4 w-4" />
      )}
    </Button>
  );
};
